import { render, staticRenderFns } from "./PlzInput.vue?vue&type=template&id=cb551a92&scoped=true"
import script from "./PlzInput.vue?vue&type=script&lang=ts"
export * from "./PlzInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb551a92",
  null
  
)

export default component.exports